import * as React from 'react';
import {IBaseView} from "../../_base/base-view";
import {inject, observer} from "mobx-react";
import {UsergroupRight} from "../../../models/rights/enum-usergrouprights";
import {TableGrid} from "../../_base/styled/table-grid";
import {TableLayout} from "../../_base/styled/layout/table-layout";
import {BaseTableFilterMenu} from "../../_base/table-filter/base-table-filter-menu";

@inject('rootStore')
@observer
export class UserTableView extends React.Component<IBaseView, {}> {

    render() {
        const {rootStore: {userStore: {ds}, authStore: {hasUserRight}}} = this.props;
        return (
            <TableLayout>
                <TableGrid
                    id="user"
                    icon="user"
                    title='USERS'
                    ds={ds}
                    singleRouteName='user'
                    hideInsert={!hasUserRight(UsergroupRight.UR_ADMIN_USER_INSERT)}
                    hideDelete={!hasUserRight(UsergroupRight.UR_ADMIN_USER_DELETE)}
                    rightHeaderMenu={
                        <BaseTableFilterMenu storeName="userStore" filtername="user"/>}
                />
            </TableLayout>
        )
    }
}